import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useFavorites } from "@/hooks/useFavorites";
import ParkingSpotCard from "@/components/search/ParkingSpotCard";
import { Loader2, Heart } from "lucide-react";

interface Spot {
  id: string;
  owner_id: string;
  owner_name: string;
  address: string;
  vehicle_type: string;
  security_type: string;
  price_per_hour: number;
  parking_lot_count: number;
  images: string[];
  is_available: boolean;
}

const Favorites = () => {
  const { favoriteIds, loading: favLoading, isAuthenticated } = useFavorites();
  const [spots, setSpots] = useState<Spot[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      if (favLoading) return;
      const ids = Array.from(favoriteIds);
      if (!ids.length) { setSpots([]); setLoading(false); return; }
      const { data } = await supabase.from("parking_spots").select("*").in("id", ids);
      setSpots((data as Spot[]) ?? []);
      setLoading(false);
    };
    fetch();
  }, [favoriteIds, favLoading]);

  if (!isAuthenticated && !favLoading) {
    return <div className="container mx-auto px-4 py-12 text-center"><p>Please sign in to view your favorite spots.</p></div>;
  }

  if (loading || favLoading) {
    return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6 flex items-center"><Heart className="h-6 w-6 mr-2 fill-red-500 text-red-500" /> My Favorites</h1>
      {spots.length === 0 ? (
        <p className="text-muted-foreground">You haven't saved any spots yet. Tap the heart on any parking spot to save it.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {spots.map((spot) => <ParkingSpotCard key={spot.id} spot={spot} />)}
        </div>
      )}
    </div>
  );
};

export default Favorites;
